import React from "react";
import { useAuth } from "@/skate/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ children, requireOnboarded = true }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="font-mono text-xs text-zinc-500 tracking-widest">LOADING…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/skate" replace />;
  if (requireOnboarded && !user.onboarded && location.pathname !== "/skate/onboarding") {
    return <Navigate to="/skate/onboarding" replace />;
  }
  return children;
};

export default ProtectedRoute;
